// @flow

import parseUserAgent from 'user-agent-parser';
import mixpanel from 'mixpanel-browser';


const userAgent = parseUserAgent(window.navigator.userAgent);
const currentYear = new Date().getFullYear();
const timestamp = String(Date.now());

// Replaces macros like `[[some_macro]]` inside a VAST URL string with the according values
// (using `queryParams` and locally available data on the device).

export default function replaceVASTMacros(url: string, queryParams: { [string]: ?string } = {}) {
    if (!url) return null;

    // These functions are used to find values for missing query parameters.
    // Using underscore syntax here to match the URL parameter name syntax.
    const macroFunctions: { [string]: (() => ?string) } = {
        timestamp: () => timestamp,
        ppid: () => queryParams.userId,
        google_aid: () => queryParams.AndroidIDFA,
        apple_idfa: () => queryParams.iOSIdFA || queryParams.idfa,
        generic_ifa: () => queryParams.iOSIdFA || queryParams.idfa || queryParams.AndroidIDFA || queryParams.device_ifa,
        generic_ifa_or_distinct_id: () => queryParams.iOSIdFA || queryParams.idfa || queryParams.AndroidIDFA || queryParams.device_ifa || mixpanel.get_distinct_id(),
        device_os: () => userAgent.os.name,
        device_osv: () => userAgent.os.version,
        device_type: () => userAgent.device.type,
        device_model: () => userAgent.device.model,
        device_vendor: () => userAgent.device.vendor,
        device_width: () => window.screen.width,
        ip: () => queryParams.ipAddress,
        device_height: () => window.screen.height,
        app_bundle: () => queryParams.packageName || queryParams.PackageName,
        app_store_url: () => queryParams.appStoreUrl || queryParams.app_storeurl,
        app_version: () => queryParams.appVersion,
        user_agent: () => window.navigator.userAgent,
        page_url: () => window.location.href.replace(/#.*$/, ''),
        dnt_true_false: () => navigator.doNotTrack ? 'true' : 'false',
        dnt_one_zero: () => navigator.doNotTrack ? '1' : '0',
        video_player_width: () => String(window.screen.width / (window.devicePixelRatio || 1)),
        video_player_height: () => String(window.screen.height / (window.devicePixelRatio || 1)),
        // replacing query string to not accidentally leaking out data
        network_type() {
            if (queryParams.type && queryParams.type.toLowerCase() === 'wifi') return 'Wifi';
            return queryParams.subType || queryParams.cellNetworkType;
        },
        gender_numeric() {
            const genderString = (queryParams.gender || 'unknown').toLowerCase();
            return String({ male: 1, female: 2 }[genderString] || 0);
        },
        gender_one_letter() {
            const genderString = (queryParams.gender || 'unknown').toLowerCase();
            return { male: 'm', female: 'f' }[genderString] || '';
        },
        gender_lowercase() {
            return queryParams.gender ? queryParams.gender.toLowerCase() : '';
        },
        gender_uppercase() {
            return queryParams.gender ? queryParams.gender.toUpperCase() : '';
        },
        yob() {
            if (queryParams.age) {
                return String(currentYear - parseInt(queryParams.age, 10));
            }
            return '';
        },
        age() {
            if (queryParams.yob) {
                return String(currentYear - parseInt(queryParams.yob, 10));
            }
            return '';
        },
    };

    const replacer = (match, macroName) => encodeURIComponent(queryParams[macroName] || (macroFunctions[macroName] && macroFunctions[macroName]()) || '');
    const urlWithReplacedMacros = url.replace(/\$\[([^\]]+)\]/g, replacer);

    return urlWithReplacedMacros;
}



// WEBPACK FOOTER //
// ./src/lib/replaceVASTMacros.js